import { AssetsService } from "app/services/AssetsService";

export const SecondaryHomePageHeaderImageUrl = AssetsService.assetUrl("/images/secondary-home-page-header-light.png");
